import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { DataTransactionParams } from "../../../definitions/api/shared/data-transaction-params";
import { DataTransactionService } from "../../../services/api/data-transaction.service";
import { DataTransactionActions } from "../../actions/data-transaction.actions";
import { FailState } from "../../models/fail-state";
import { DataTransactionsState } from "../../models/shared/data-transactions-state";
import { AppState } from "../../reducers";
import { DataTransactionsSelectors } from "../../selectors/data-transactions.selectors";

@Injectable()
export class DataTransactionsGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(DataTransactionActions.dataTransactions.get),
			withLatestFrom(this.store.select(DataTransactionsSelectors.dataTransactions)),
			switchMap(([action, state]) =>
				DataTransactionsGetEffects.canUseStoreValue(action, state)
					? of(DataTransactionActions.dataTransactions.getSuccess(state))
					: of(DataTransactionActions.dataTransactions.getApi({ params: action.params }))
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(DataTransactionActions.dataTransactions.getApi),
			switchMap((action) =>
				this.dataTransactionService.dataTransactions(action.params).pipe(
					map((transactions) => {
						const searchHistory = action.params ? [action.params] : undefined;
						return DataTransactionActions.dataTransactions.getSuccess({
							transactions,
							searchHistory,
							loading: false
						});
					}),
					catchError((error) =>
						of(DataTransactionActions.dataTransactions.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private store: Store<AppState>,
		private dataTransactionService: DataTransactionService
	) {}

	private static canUseStoreValue(action, state: DataTransactionsState): boolean {
		return (
			!_.has(state, "error") &&
			!state.loading &&
			!!_.find(_.get(state, "searchHistory", []), (params: DataTransactionParams) =>
				_.isEqual(params, action.params)
			)
		);
	}
}
